import React from "react";
import Catalog from "./catalog";

const Graduation = () => {
  
  return (
    <div>
      <Catalog set_type="graduation" />
    </div>
  );
};

export default Graduation;